/**
 Validates org numbers from UnitedArabEmirates
 */
export const validateUnitedArabEmiratesOrgNumber = (number: string) => {
  const unitedArabEmiratesOrgNumberRegex = /^\d{4,5}$/g;
  return unitedArabEmiratesOrgNumberRegex.test(number);
};
